import AIModelGenerator from "./components/AIModelGenerator";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "./Loader";
import {
  Button,
  Grid,
  Typography,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import darkBubble from "./component_assets/images/darkBubble.png";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import lightBubble from "./component_assets/images/lightBubble.png";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import "./style.css";
import DeleteIcon from "@mui/icons-material/Delete";
import RateReviewIcon from "@mui/icons-material/RateReview";
import CloseIcon from "@mui/icons-material/Close";
import errorSymbol from "./component_assets/images/errorSymbol.svg";
import btnGrp from "./component_assets/images/btnGrpRed.svg";
import errorWave from "./component_assets/images/errorWave.svg";
import { getAllModels, updateModal } from "../Redux/Actions/customTableActions";
import { API_HOST } from "../api_utils";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import handleFile from "../handleImports";
import { Tooltip } from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";
import classes from "./ScreensStylings/AllCustomModels.module.css";
import { FiSearch } from "react-icons/fi";
import slingai from "../assets/images/slingai.svg";
import { deleteDataModels } from "../API/data-models";
import axios from "axios";

const notifyTheme = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const successTheme = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

let user = "";
const userInfo = localStorage.getItem("userInfo");
if (userInfo) {
  const parsedUserInfo = JSON.parse(userInfo);
  if (parsedUserInfo && parsedUserInfo.email) {
    user = parsedUserInfo.email;
  }
}

const allowedUsers = [
  "demo@redsling.com",
  "yeodw@bizeni.com",
  "jihyun.bae@bizeni.com",
];
const isAllowedUser = allowedUsers.includes(user);

const infoTheme = {
  position: "top-right",
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

export default function AllCustomModels() {
  let dispatch = useDispatch();
  let navigate = useNavigate();

  const { customTables, loading, error, emptyCustomTables } = useSelector(
    (state) => state.customTables
  );
  const { allProjectData } = useSelector((state) => state.allProjectData);
  const { userInfo } = useSelector((state) => state.userLogin);
  const token = userInfo.token;
  const { updatedModalData } = useSelector((state) => state.updateModal);
  const [tableReferenceList, setTableReferenceList] = useState([]);
  const [modalData, setModalData] = useState({
    tableName: "",
    fieldName: "",
    fieldType: "",
    fieldType1: "",
    fields: [],
    success: false,
    referenceTables: [],
    referenceTableId: "",
  });
  const [open, setOpen] = useState(false);
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [tableName, setTableName] = useState("");
  const [fieldType, setFieldType] = useState("");
  const [fieldName, setFieldName] = useState();
  const [customTableName, setCustomTableName] = useState("");
  const [modal_field_type, setModalFieldType] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const searchFilterOptionsShowNickname = useRef(true);
  const [customTableNameFilter, setCustomTableNameFilter] = useState("");
  const [selectedCustomTableName, setSelectedCustomTableName] = useState("");
  const [
    finalCustomTableNameToFilterData,
    setFinalCustomTableNameToFilterData,
  ] = useState("");

  const [tableNameModal, setTableNameModal] = useState(false);
  const [deleteModelOpen, setDeleteModelOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const tableNameRef = useRef(null);
  const [projectName, setProjectName] = useState("");

  // New refs for enhanced import functionality
  const dataModelNameRef = useRef();
  const apiMethodRef = useRef();
  const primaryKeyRef = useRef();
  const sheetColumnsRef = useRef();
  const responseKeysRef = useRef();
  const requiredFieldsRef = useRef();
  const fileRef = useRef();

  // New state for invalid values
  const [invalidValues, setInvalidValues] = useState([
    { column: "", action: "fail" },
  ]);

  // New state for file preview
  const [selectedFile, setSelectedFile] = useState(null);

  const { project } = useParams();

  const xlFileInputRef = useRef(null);

  const [btnLoading, setBtnLoading] = useState(false);
  const [isPrimaryKeyEditable, setIsPrimaryKeyEditable] = useState(false);

  useEffect(() => {
    dispatch(getAllModels(project));
  }, [updatedModalData]);

  // File handling functions
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };

  const handleCloseImportModal = () => {
    setTableNameModal(false);
    setSelectedFile(null);
    setIsPrimaryKeyEditable(false);
    // Reset all form refs
    if (dataModelNameRef.current) dataModelNameRef.current.value = "";
    if (primaryKeyRef.current) primaryKeyRef.current.value = "";
    if (sheetColumnsRef.current) sheetColumnsRef.current.value = "";
    if (responseKeysRef.current) responseKeysRef.current.value = "";
    if (requiredFieldsRef.current) requiredFieldsRef.current.value = "";
    if (fileRef.current) fileRef.current.value = "";
    setInvalidValues([{ column: "", action: "fail" }]);
  };

  const setFields = () => {
    let savingFields = [
      ...modalData.fields,
      { field_name: "", field_type: "", fieldType1: "" },
    ];

    setModalData((prevState) => ({
      ...prevState,
      fields: savingFields,
    }));
  };

  const handleReferenceChange = (e, index) => {
    if (
      modalData &&
      modalData.fields &&
      index >= 0 &&
      index < modalData.fields.length
    ) {
      const addNewFieldType = modalData.fields.find((x, i) => i === index);
      addNewFieldType.referenceTableId = e.target.value;

      if (addNewFieldType) {
        const updatedFields = modalData.fields.map((x, i) => {
          const newField = {
            ...addNewFieldType,
            referenceTableId: e.target.value,
          };

          if (i === index) {
            return newField;
          } else {
            return x;
          }
        });

        setModalData((prevState) => ({
          ...prevState,
          referenceTables: updatedFields,
        }));
      }
    }
  };

  useEffect(() => {
    if (customTables.length) {
      const tableInsideProject = customTables.filter(
        (x) => x.project === project
      );
      let tableName = [];
      if (tableInsideProject?.length) {
        tableName = tableInsideProject.map((x) => ({
          name: x.table_name,
          value: x._id,
        }));
      }
      tableName?.push({
        name: "none",
        value: "none",
      });
      setTableReferenceList(tableName);
    }
  }, [customTables, project]);

  const handleDeleteClose = () => {
    setDeleteModelOpen(false);
  };

  const handleAiModalClose = () => {
    setAiModalOpen(false);
  };

  const aiHandler = () => {
    setAiModalOpen(true);
  };

  const handleDeleteClick = (id) => {
    setSelectedDeleteId(id);
    setDeleteModelOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const createTable = () => {
    navigate(`/create_modal/${project}`);
  };

  const externalDataHandler = () => {
    navigate(`/externaltables/${project}`);
  };

  const handleRowEventHandler = (params) => {
    setModalData({
      _id: params.row.id,
      table_name: params.row.customTableNameOriginal,
      table_name1: params.row.customTableName,
      fields: params.row.fields,
      userToken: params.row.userToken,
      api: params.row.api,
    });
    setOpen(true);
  };

  const CopyButton = ({ text }) => (
    <CopyToClipboard text={text}>
      <Button
        variant="contained"
        color="primary"
        sx={{ marginRight: "0.5vw", backgroundColor: "red" }}
      >
        Copy
      </Button>
    </CopyToClipboard>
  );

  const handleConfirmDelete = async () => {
    try {
      const response = await deleteDataModels(selectedDeleteId, token);
      if (response.success) {
        dispatch(getAllModels(project));
      }
      setDeleteModelOpen(false);
    } catch (error) {
      console.error("Delete failed:", error);
      setDeleteModelOpen(false);
    }
  };

  useEffect(() => {
    if (customTables && !customTableNameFilter) {
      setFilteredData(customTables);
    }
  }, [customTables, customTableNameFilter]);

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "customTableName",
      headerName: "Table Name",
      width: 180,
      editable: false,
    },
    {
      field: "fields",
      headerName: "Fields",
      width: 500,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              padding: "1rem 0.5rem",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
            }}
          >
            {params.row.fields.length > 1 ? (
              params.row.fields.map((x) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    width: "100%",
                  }}
                >
                  <Typography sx={{ width: "60%" }}>
                    <strong>Field Name</strong>: {x.field_name}
                  </Typography>
                  <Typography>
                    <strong>Field Type</strong> :{x.field_type}
                  </Typography>
                </div>
              ))
            ) : (
              <>
                {" "}
                <Typography>
                  <strong>Field Name</strong>: {params.row.fields[0].field_name}
                </Typography>
                <Typography>
                  <strong>Field Type</strong> :{params.row.fields[0].field_type}
                </Typography>
              </>
            )}
          </Box>
        );
      },
    },
    {
      field: "userToken",
      headerName: "User Token",
      width: 200,
      editable: false,
      wrapText: true,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <CopyButton text={params.value} />
            <Typography>{params.value}</Typography>
          </Box>
        </Tooltip>
      ),
    },
    {
      field: "api",
      headerName: "API",
      width: 200,
      editable: false,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <CopyButton text={params.value} />
            <Typography>{params.value}</Typography>
          </Box>
        </Tooltip>
      ),
    },
    {
      field: "Details",
      headerName: "Update",
      width: 90,
      renderCell: (params) => {
        return (
          <Typography
            onClick={(event) => {
              handleRowEventHandler(params);
            }}
            sx={{
              color: "#e11d48",
              "&:hover": { color: "#fb7185", scale: "125%" },
            }}
          >
            <RateReviewIcon fontSize="medium" />
          </Typography>
        );
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 90,
      renderCell: (params) => {
        return (
          <Typography
            onClick={(event) => {
              event.stopPropagation();
              handleDeleteClick(params.id);
            }}
            sx={{
              color: "#e11d48",
              "&:hover": { color: "#fb7185", scale: "125%" },
            }}
          >
            <DeleteIcon fontSize="medium" />
          </Typography>
        );
      },
    },
  ];

  let rows =
    filteredData.length > 0
      ? filteredData?.map((x) => {
          let user = JSON.parse(localStorage.getItem("userInfo"));
          let apiEndPoint = `${API_HOST}customroutes/data_grid/${x.table_name}`;
          return {
            id: x._id,
            customTableName:
              x.table_name.indexOf("_") !== -1
                ? x.table_name.substring(x.table_name.indexOf("_") + 1)
                : x.table_name,
            customTableNameOriginal: x.table_name,
            fields: x.fields,
            userToken: user.token,
            api: apiEndPoint,
          };
        })
      : [];

  const updateModelHandler = () => {
    const fields = modalData?.fields;
    const referenceTables = modalData?.referenceTables;
    dispatch(
      updateModal({
        fields,
        table_name: modalData.table_name,
        model_id: modalData._id,
        referenceTables: referenceTables,
      })
    );
    setOpen(false);
  };

  // New handlers for invalid values
  const handleInvalidChange = (index, key, value) => {
    const updated = [...invalidValues];
    updated[index][key] = value;
    setInvalidValues(updated);
  };

  const addInvalidRow = () => {
    setInvalidValues([...invalidValues, { column: "", action: "fail" }]);
  };

  const removeInvalidRow = (index) => {
    const updated = invalidValues.filter((_, i) => i !== index);
    setInvalidValues(updated);
  };

  // Enhanced submit handler
  const tableNameSubmitHandler = async (e) => {
    e.preventDefault();
    setBtnLoading(true);

    const jsonData = {
      baseUrl: `${API_HOST}`,
      dataModelNameValue: dataModelNameRef.current.value,
      apiMethodValue: apiMethodRef.current.value,
      apiMoreHeadersValue: "",
      primaryKey: primaryKeyRef.current.value,
      sheetColumns: sheetColumnsRef.current.value
        .split(",")
        .map((s) => s.trim())
        .filter((x) => x),
      apiResponseColumnKeynames: responseKeysRef.current.value
        .split(",")
        .map((s) => s.trim())
        .filter((x) => x),
      requiredFields: requiredFieldsRef.current.value
        .split(",")
        .map((s) => s.trim())
        .filter((x) => x),
      invalidValue: invalidValues.reduce((acc, { column, action }) => {
        if (column)
          acc[column] = action === "fail" ? "ImportFails" : "SkipValue";
        return acc;
      }, {}),
      projectId: project,
      dynamicBaseUrlBearerToken: token,
    };

    const formData = new FormData();
    formData.append("jsonData", JSON.stringify(jsonData));
    if (fileRef.current.files.length > 0) {
      formData.append("file", fileRef.current.files[0]);
    }

    try {
      await axios.post(`${API_HOST}api/excel-import/form-upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setBtnLoading(false);
      toast.success("File imported successfully!", successTheme);
      handleCloseImportModal();
    } catch (err) {
      setBtnLoading(false);
      console.error("Upload failed:", err.response || err);
      toast.error(err.response?.data?.message || err.message, successTheme);
    }
  };

  const importHandler = () => {
    setTableNameModal(true);
  };

  const handleCustomerNicknameChange = useCallback((e) => {
    setCustomTableNameFilter(e.target.value);
  }, []);

  useEffect(() => {
    if (project && allProjectData.length) {
      let currentProject = allProjectData.find((x) => x._id === project);
      if (currentProject) {
        setProjectName(currentProject.project_name);
      }
    }
  }, [allProjectData]);

  const filteredNicknameOptions = useMemo(() => {
    if (customTableNameFilter && !selectedCustomTableName) {
      console.log("project:::::", project);

      let projectNameFilterNew;

      if (projectName.includes("'s")) {
        let projectNameNew = projectName.replace(/'s/g, "s");
        projectNameNew = projectNameNew.replace(/\s/g, "");
        projectNameFilterNew = `${projectNameNew}_${customTableNameFilter}`;
      } else {
        let projectNameNew = projectName.replace(/\s/g, "");
        projectNameFilterNew = `${projectNameNew}_${customTableNameFilter}`;
      }

      console.log("projectNameFilterNew:::::", projectNameFilterNew);

      const searchTerm = projectNameFilterNew.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      customTables.forEach((option) => {
        console.log("option:::", option.table_name);

        if (
          option.table_name &&
          option.table_name.toLowerCase().startsWith(searchTerm)
        ) {
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.table_name.localeCompare(b.table_name, undefined, {
          sensitivity: "base",
        })
      );

      return optionsStartingWithSearchTerm;
    } else {
      if (selectedCustomTableName) {
        setFinalCustomTableNameToFilterData(selectedCustomTableName);
        setSelectedCustomTableName("");

        searchFilterOptionsShowNickname.current = false;
      } else {
        searchFilterOptionsShowNickname.current = true;
      }

      return [];
    }
  }, [customTableNameFilter, selectedCustomTableName]);

  useEffect(() => {
    if (finalCustomTableNameToFilterData) {
      let newFilteredData = customTables.filter(
        (item) => item.table_name === finalCustomTableNameToFilterData
      );
      setFilteredData(newFilteredData);
    }

    return () => {
      setFinalCustomTableNameToFilterData("");
    };
  }, [finalCustomTableNameToFilterData]);

  return (
    <div className="" style={{ minHeight: "" }}>
      {loading ? (
        <Loader />
      ) : emptyCustomTables ? (
        <Grid
          sx={{
            height: "87.5vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Grid
            width={"80vw"}
            height={"80%"}
            sx={{
              padding: "2vh 0 2vh 3vw",
              borderRadius: "8px",
              backdropFilter: "blur(25px)",
              boxShadow: 20,
              zIndex: 20,
            }}
          >
            <Grid
              xs={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{ fontFamily: "Mont-SemiBold", fontSize: "1.5rem" }}
              >
                Projects Created
              </Typography>
              <Grid
                xs={9}
                sx={{ backgroundColor: "red", height: "0.6vh" }}
              ></Grid>
            </Grid>
            <Grid sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
              <img src={errorSymbol} style={{ height: "30vh" }} />
            </Grid>
            <Typography
              sx={{
                textAlign: "center",
                mt: 4,
                fontSize: "1.2rem",
                fontFamily: "Mont-SemiBold",
              }}
            >
              Sorry! No Projects have been created yet.{" "}
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <Button
                onClick={createTable}
                variant="contained"
                sx={{
                  backgroundColor: "white",
                  color: "black",
                  fontFamily: "Mont-Regular",
                }}
              >
                <span style={{ marginRight: "1vw" }}>Create New Project</span>
                <img src={btnGrp} style={{ height: "4vh" }} />
              </Button>
            </Grid>
          </Grid>
          <Grid sx={{ position: "absolute", bottom: "-80vh", right: "-20vw" }}>
            <img src={lightBubble} style={{ height: "160vh" }} />
          </Grid>
          <Grid sx={{ position: "absolute", top: "-12vh", right: "0" }}>
            <img src={errorWave} style={{ height: "180vh" }} />
          </Grid>
        </Grid>
      ) : (
        <Grid
          sx={{ position: "relative", overflow: "hidden", height: "100vh" }}
        >
          <Grid
            sx={{
              position: "absolute",
              top: "-12vh",
              left: "-30vw",
              zIndex: "-10",
            }}
          >
            <img style={{ width: "55vw", height: "90%" }} src={darkBubble} />
          </Grid>

          <Grid sx={{ position: "absolute", bottom: "-60%", right: "-15%" }}>
            <img style={{ width: "55vw", height: "90%" }} src={lightBubble} />
          </Grid>

          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              paddingTop: "10vh",
            }}
          >
            <Box
              sx={{
                minHeight: "58vh",
                width: "90%",
                backdropFilter: "blur(25)",
                backgroundColor: "",
              }}
            >
              <Grid
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                container
              >
                <Typography
                  sx={{
                    fontFamily: "Mont-SemiBold",
                    fontSize: "1.8rem",
                  }}
                >
                  Data Models
                </Typography>
                <Grid
                  xs={10}
                  sx={{ height: "1.5vh", backgroundColor: "red" }}
                  item
                ></Grid>
              </Grid>
              <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ position: "relative", width: "50%" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      borderRadius: "10px",
                      border: "1.5px solid #c1c4c8",
                      paddingLeft: "0.5rem",
                      backgroundColor: "white",
                    }}
                  >
                    <FiSearch fontSize="x-large" />
                    <input
                      type="text"
                      value={customTableNameFilter}
                      placeholder="Search By Table Name"
                      onInput={(e) => {
                        console.log("e.target::::::", e.target.value);
                        handleCustomerNicknameChange(e);
                      }}
                      style={{
                        outline: "none",
                        border: "none",
                        width: "80%",
                        paddingTop: "0.5rem",
                        paddingBottom: "0.5rem",
                        marginLeft: "0.5rem",
                      }}
                    />
                  </div>

                  {filteredNicknameOptions.length > 0 && (
                    <div
                      style={{ zIndex: 11, top: "3rem" }}
                      className={
                        searchFilterOptionsShowNickname.current
                          ? "position-absolute  lg-max-h-12rem  xl-max-h-12rem  2xl-max-h-13rem overflow-auto w-100 rounded-lg shadow d-block "
                          : "d-none"
                      }
                    >
                      {filteredNicknameOptions.map((option, index) => (
                        <div
                          className="custom-search-filter"
                          onClick={() => {
                            setSelectedCustomTableName(option.table_name);
                            setCustomTableName(option.table_name);
                          }}
                          key={index}
                        >
                          {option.table_name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Enhanced Import Modal */}
                {tableNameModal && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <Box
                      sx={{
                        overflowY: "auto",
                        maxHeight: "80vh",
                        width: { lg: "90vw" },
                        padding: "2vh 2vw 4vh 2vw",
                        outline: "none",
                        borderRadius: "6px",
                        backgroundColor: "#f8f9fa",
                        position: "relative",
                        marginTop: "-4vh",
                        marginLeft: "4vh",
                      }}
                    >
                      {/* Header - Fixed */}
                      <Grid
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          onClick={handleCloseImportModal}
                          sx={{
                            boxShadow: 2,
                            color: "red",
                            "&:hover": { boxShadow: 5 },
                          }}
                        >
                          <CloseIcon />
                        </Button>
                      </Grid>

                      <Grid
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 2,
                          mb: 3,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "Mont-SemiBold",
                            fontSize: "1.5rem",
                          }}
                        >
                          Configure Data Model
                        </Typography>
                        <Grid
                          item
                          xs={8.8}
                          sx={{ backgroundColor: "red", height: "1vh" }}
                        ></Grid>
                      </Grid>

                      {/* Main Content Area */}
                      {btnLoading ? (
                        <Loader />
                      ) : (
                        <Grid container spacing={3} sx={{ height: "60vh" }}>
                          {/* Form Section */}
                          <Grid item xs={12} md={6} sx={{ height: "100%" }}>
                            <Box
                              sx={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                padding: "1.5rem",
                                boxShadow: 2,
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Mont-SemiBold",
                                  fontSize: "1.2rem",
                                  mb: 2,
                                  color: "#333",
                                  flexShrink: 0,
                                }}
                              >
                                Model Configuration
                              </Typography>

                              {/* Scrollable Form Content */}
                              <Box
                                sx={{
                                  flex: 1,
                                  overflowY: "auto",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                  "&::-webkit-scrollbar": {
                                    width: "6px",
                                  },
                                  "&::-webkit-scrollbar-track": {
                                    backgroundColor: "#f1f1f1",
                                    borderRadius: "10px",
                                  },
                                  "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#c1c1c1",
                                    borderRadius: "10px",
                                  },
                                  "&::-webkit-scrollbar-thumb:hover": {
                                    backgroundColor: "#a8a8a8",
                                  },
                                }}
                              >
                                {/* Data Model Name */}
                                <div>
                                  <label
                                    htmlFor="dataModelNameValue"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    Data Model Name
                                  </label>
                                  <input
                                    type="text"
                                    id="dataModelNameValue"
                                    ref={dataModelNameRef}
                                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300"
                                  />
                                </div>

                                {/* API Method */}
                                <div>
                                  <label
                                    htmlFor="apiMethodValue"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    API Method
                                  </label>
                                  <select
                                    id="apiMethodValue"
                                    ref={apiMethodRef}
                                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300"
                                  >
                                    <option value="IncrementalImport">
                                      Incremental Import
                                    </option>
                                    <option value="ClearAndImport">
                                      Clear and Import
                                    </option>
                                  </select>
                                </div>

                                {/* Primary Key */}
                                {/* <div>
                                  <label
                                    htmlFor="primaryKey"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    Primary Key
                                  </label>
                                  <input
                                    type="text"
                                    id="primaryKey"
                                    ref={primaryKeyRef}
                                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300"
                                  />
                                </div> */}
                                {/* Primary Key */}
                                <div>
                                  <label
                                    htmlFor="primaryKey"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    Primary Key
                                  </label>
                                  <div className="relative">
                                    <input
                                      type="text"
                                      id="primaryKey"
                                      ref={primaryKeyRef}
                                      defaultValue="_id"
                                      disabled={!isPrimaryKeyEditable}
                                      onBlur={() =>
                                        setIsPrimaryKeyEditable(false)
                                      }
                                      className={`w-full border border-gray-300 rounded-lg px-4 py-2 pr-12 focus:outline-none focus:ring-2 focus:ring-red-300 ${
                                        !isPrimaryKeyEditable
                                          ? "bg-gray-100 text-gray-600 cursor-not-allowed"
                                          : "bg-white"
                                      }`}
                                    />
                                    {!isPrimaryKeyEditable && (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          setIsPrimaryKeyEditable(true);
                                          // Focus the input after making it editable
                                          setTimeout(() => {
                                            primaryKeyRef.current?.focus();
                                          }, 0);
                                        }}
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1.5 hover:bg-gray-300 rounded-full transition-colors border-l border-gray-300 bg-gray-50"
                                        aria-label="Edit primary key"
                                      >
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="text-gray-600"
                                        >
                                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                          <path d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                        </svg>
                                      </button>
                                    )}
                                  </div>
                                </div>

                                {/* Sheet Columns */}
                                <div>
                                  <label
                                    htmlFor="sheetColumns"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    Sheet Columns
                                    <span className="text-sm text-gray-500">
                                      {" "}
                                      (comma-separated)
                                    </span>
                                  </label>
                                  <textarea
                                    id="sheetColumns"
                                    ref={sheetColumnsRef}
                                    rows={2}
                                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300 resize-none"
                                  />
                                </div>

                                {/* API Response Keynames */}
                                <div>
                                  <label
                                    htmlFor="apiResponseColumnKeynames"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    API Response Keynames
                                    <span className="text-sm text-gray-500">
                                      {" "}
                                      (comma-separated)
                                    </span>
                                  </label>
                                  <textarea
                                    id="apiResponseColumnKeynames"
                                    ref={responseKeysRef}
                                    rows={2}
                                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300 resize-none"
                                  />
                                </div>

                                {/* Required Fields */}
                                <div>
                                  <label
                                    htmlFor="requiredFields"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    Required Fields
                                    <span className="text-sm text-gray-500">
                                      {" "}
                                      (comma-separated)
                                    </span>
                                  </label>
                                  <textarea
                                    id="requiredFields"
                                    ref={requiredFieldsRef}
                                    rows={2}
                                    className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300 resize-none"
                                  />
                                </div>
                              </Box>
                            </Box>
                          </Grid>

                          {/* File Upload and Rules Section */}
                          <Grid item xs={12} md={6} sx={{ height: "100%" }}>
                            <Box
                              sx={{
                                backgroundColor: "white",
                                borderRadius: "8px",
                                padding: "1.5rem",
                                boxShadow: 2,
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: "Mont-SemiBold",
                                  fontSize: "1.2rem",
                                  mb: 2,
                                  color: "#333",
                                  flexShrink: 0,
                                }}
                              >
                                File Upload & Rules
                              </Typography>

                              {/* Scrollable Content */}
                              <Box
                                sx={{
                                  flex: 1,
                                  overflowY: "auto",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                  "&::-webkit-scrollbar": {
                                    width: "6px",
                                  },
                                  "&::-webkit-scrollbar-track": {
                                    backgroundColor: "#f1f1f1",
                                    borderRadius: "10px",
                                  },
                                  "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#c1c1c1",
                                    borderRadius: "10px",
                                  },
                                  "&::-webkit-scrollbar-thumb:hover": {
                                    backgroundColor: "#a8a8a8",
                                  },
                                }}
                              >
                                {/* File Upload */}
                                <div>
                                  <label
                                    htmlFor="fileUpload"
                                    className="block font-medium mb-1 text-gray-900"
                                  >
                                    Upload File
                                  </label>
                                  <label
                                    htmlFor="fileUpload"
                                    className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg py-6 cursor-pointer hover:border-red-600 transition"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-6 w-6 text-gray-400"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M7 16V4m0 0L3 8m4-4 4 4M17 8v10m0 0l-4-4m4 4 4-4"
                                      />
                                    </svg>
                                    <span className="ml-3 text-gray-600">
                                      {selectedFile
                                        ? "Click to change file"
                                        : "Click to select a file"}
                                    </span>
                                    <input
                                      type="file"
                                      id="fileUpload"
                                      name="file"
                                      ref={fileRef}
                                      onChange={handleFileSelect}
                                      accept=".csv, .xlsx, .xls"
                                      className="hidden"
                                    />
                                  </label>

                                  {/* File Preview */}
                                  {selectedFile && (
                                    <div className="mt-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-5 w-5 text-green-600 mr-2"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                            />
                                          </svg>
                                          <div>
                                            <p className="text-sm font-medium text-gray-900">
                                              {selectedFile.name}
                                            </p>
                                            <p className="text-xs text-gray-500">
                                              {(
                                                selectedFile.size / 1024
                                              ).toFixed(2)}{" "}
                                              KB •{" "}
                                              {selectedFile.type ||
                                                "Unknown type"}
                                            </p>
                                          </div>
                                        </div>
                                        <button
                                          onClick={handleRemoveFile}
                                          className="text-red-600 hover:text-red-800 p-1"
                                          type="button"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={2}
                                              d="M6 18L18 6M6 6l12 12"
                                            />
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {/* Invalid Value Rules */}
                                <div>
                                  <h3 className="font-medium text-gray-900 mb-3">
                                    Invalid Value Rules
                                  </h3>
                                  <div className="space-y-4">
                                    {invalidValues.map((item, i) => (
                                      <div
                                        key={i}
                                        className="flex gap-4 items-center"
                                      >
                                        <input
                                          type="text"
                                          placeholder="Sheet Column"
                                          value={item.column}
                                          onChange={(e) =>
                                            handleInvalidChange(
                                              i,
                                              "column",
                                              e.target.value
                                            )
                                          }
                                          className="flex-1 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300"
                                        />
                                        <select
                                          value={item.action}
                                          onChange={(e) =>
                                            handleInvalidChange(
                                              i,
                                              "action",
                                              e.target.value
                                            )
                                          }
                                          className="w-40 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-red-300"
                                        >
                                          <option value="fail">
                                            Fail Import
                                          </option>
                                          <option value="skip">
                                            Skip Value
                                          </option>
                                        </select>
                                        <button
                                          onClick={() => removeInvalidRow(i)}
                                          className="text-red-600 hover:text-red-800 text-2xl"
                                        >
                                          &minus;
                                        </button>
                                      </div>
                                    ))}

                                    <button
                                      onClick={addInvalidRow}
                                      className="inline-block bg-red-600 text-white px-5 py-2 rounded-lg hover:bg-red-700 transition"
                                    >
                                      + Add Rule
                                    </button>
                                  </div>
                                </div>
                              </Box>

                              {/* Footer - Fixed at bottom of this section */}
                              <Box
                                sx={{
                                  mt: 2,
                                  pt: 2,
                                  borderTop: "1px solid #e5e7eb",
                                  flexShrink: 0,
                                }}
                              >
                                <div className="flex justify-end gap-4">
                                  <button
                                    onClick={handleCloseImportModal}
                                    className="bg-gray-200 text-gray-800 px-6 py-2 rounded-lg hover:bg-gray-300 transition"
                                  >
                                    Close
                                  </button>
                                  <button
                                    onClick={tableNameSubmitHandler}
                                    className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>
                      )}
                    </Box>
                  </div>
                )}

                <input
                  type="file"
                  id="file-input"
                  accept=".csv, .xlsx"
                  ref={xlFileInputRef}
                  style={{ display: "none" }}
                />
                {isAllowedUser && (
                  <Button
                    title="External Data APIs"
                    onClick={externalDataHandler}
                    variant="contained"
                    sx={{
                      fontFamily: "Mont-Regular",
                      backgroundColor: "red",
                      marginBottom: "3vh",
                      marginRight: "1em",
                      "&:hover": { color: "red", backgroundColor: "white" },
                      transitionDuration: "0.5s",
                    }}
                  >
                    External Data APIs
                  </Button>
                )}

                <div style={{ display: "flex" }}>
                  <Button
                    title="Import excel/CSV file"
                    onClick={importHandler}
                    variant="contained"
                    sx={{
                      fontFamily: "Mont-Regular",
                      backgroundColor: "red",
                      marginBottom: "3vh",
                      marginRight: "1em",
                      "&:hover": { color: "red", backgroundColor: "white" },
                      transitionDuration: "0.5s",
                    }}
                  >
                    Import File
                  </Button>

                  <button
                    onClick={aiHandler}
                    className="group relative flex items-center justify-center mx-4 border border-black h-8 w-16 px-5 py-0.5 rounded-sm transition-all duration-300 hover:border-red-500 overflow-visible"
                  >
                    <div className="absolute inset-0 rounded-sm">
                      <div className="absolute inset-0 rounded-sm border-2 border-red-500 opacity-0 group-hover:opacity-100 group-hover:animate-ping"></div>
                      <div className="absolute inset-0 rounded-sm border border-red-300 opacity-0 group-hover:opacity-75 group-hover:animate-ping animation-delay-150"></div>
                    </div>

                    <div className="absolute inset-0 bg-gradient-to-r from-red-50 to-red-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-sm"></div>

                    <img
                      src={slingai}
                      className="w-12 h-12 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:drop-shadow-md"
                    />
                    <span className="font-semibold text-red-500 group-hover:text-red-700 transition-colors duration-300 relative z-10">
                      SlingAI
                    </span>
                  </button>

                  <Button
                    onClick={createTable}
                    variant="contained"
                    sx={{
                      fontFamily: "Mont-Regular",
                      backgroundColor: "red",
                      marginBottom: "3vh",
                      "&:hover": { color: "red", backgroundColor: "white" },
                      transitionDuration: "0.5s",
                    }}
                  >
                    Create New Table
                  </Button>
                </div>
              </Grid>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={5}
                error={error}
                rowsPerPageOptions={[5]}
                checkboxSelection
                disableSelectionOnClick
                getRowHeight={() => "auto"}
                localeText={{ noRowsLabel: "No Tables created" }}
              />
            </Box>
          </Grid>
        </Grid>
      )}

      <Dialog open={deleteModelOpen} onClose={handleDeleteClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this data model?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          border: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            overflowY: "scroll",
            maxHeight: "80vh",
            width: { lg: "80vw" },
            padding: "2vh 2vw 6vh 2vw",
            outline: "none",
            borderRadius: "6px",
            backgroundColor: "white",
            position: "relative",
          }}
        >
          <Grid sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleClose}
              sx={{ boxShadow: 2, color: "red", "&:hover": { boxShadow: 5 } }}
            >
              <CloseIcon />
            </Button>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Typography
              sx={{ fontFamily: "Mont-SemiBold", fontSize: "1.3rem" }}
            >
              Update Data Model
            </Typography>
            <Grid
              item
              xs={9}
              sx={{ backgroundColor: "red", height: "1vh" }}
            ></Grid>
          </Grid>

          <Grid container sx={{ mt: 4 }}>
            <Grid item sx={{ width: "100%" }}>
              <TextField
                onChange={(e) => setTableName(e.target.value)}
                id="outlined-basic"
                label="Table Name"
                variant="outlined"
                sx={{ width: "100%" }}
                disabled
                defaultValue={modalData?.table_name1}
              />
            </Grid>
          </Grid>
          <Divider sx={{ mt: 2, border: "1px solid gray !important" }} />
          <Grid
            container
            sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}
          >
            {modalData?.fields.map((x, index) => (
              <>
                <Grid item xs={5} sx={{ mt: 3 }}>
                  <TextField
                    onChange={(e) => {
                      const updatedFields = [...modalData.fields];
                      updatedFields[index].field_name = e.target.value;
                      setModalData({ ...modalData, fields: updatedFields });
                    }}
                    id="outlined-basic"
                    label="Field Name"
                    variant="outlined"
                    sx={{ width: "100%" }}
                    defaultValue={x.field_name}
                  />
                </Grid>
                {x.field_type === "Reference" && (
                  <Grid item xs={2.5} sx={{ mt: 1.5 }}>
                    {" "}
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Field Type
                      </InputLabel>
                      <Select
                        key={index}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={x.field_type}
                        label="Field Type"
                        onChange={(e) => {
                          const updatedFields = [...modalData.fields];
                          updatedFields[index].field_type = e.target.value;
                          setModalData({ ...modalData, fields: updatedFields });
                        }}
                      >
                        <MenuItem value={"String"}>String</MenuItem>
                        <MenuItem value={"Boolean"}>Boolean</MenuItem>
                        <MenuItem value={"Number"}>Number</MenuItem>
                        <MenuItem value={"Reference"}>Reference</MenuItem>
                        <MenuItem value={"Date-Time"}>Date-Time</MenuItem>
                        <MenuItem value={"Time"}>Time</MenuItem>
                        <MenuItem value={"File"}>File</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {x.field_type !== "Reference" && (
                  <Grid item xs={5} sx={{ mt: 3 }}>
                    {" "}
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Field Type
                      </InputLabel>
                      <Select
                        key={index}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={x.field_type}
                        label="Field Type"
                        onChange={(e) => {
                          const updatedFields = [...modalData.fields];
                          updatedFields[index].field_type = e.target.value;
                          setModalData({ ...modalData, fields: updatedFields });
                        }}
                      >
                        <MenuItem value={"String"}>String</MenuItem>
                        <MenuItem value={"Boolean"}>Boolean</MenuItem>
                        <MenuItem value={"Number"}>Number</MenuItem>
                        <MenuItem value={"Reference"}>Reference</MenuItem>
                        <MenuItem value={"Date-Time"}>Date-Time</MenuItem>
                        <MenuItem value={"Time"}>Time</MenuItem>
                        <MenuItem value={"File"}>File</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {x.field_type === "Reference" && (
                  <Grid item xs={2.5} sx={{ mt: 1.5 }}>
                    <FormControl fullWidth>
                      <InputLabel>Reference Table</InputLabel>
                      <Select
                        labelId={`demo-simple-select-label`}
                        id={`demo-simple-select`}
                        label="Select Reference Table"
                        value={x?.referenceTableId || ""}
                        onChange={(e) => {
                          if (
                            index >= 0 &&
                            index < tableReferenceList?.length
                          ) {
                            handleReferenceChange(e, index);
                          } else {
                          }
                        }}
                      >
                        {tableReferenceList.length
                          ? tableReferenceList.map((y, i) => (
                              <MenuItem
                                key={`${y.value}-${i}`}
                                data-id={i}
                                data-category={y.name}
                                value={y.value}
                              >
                                {y.name}
                              </MenuItem>
                            ))
                          : ""}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                <Grid xs={1}>
                  {index === modalData?.fields.length - 1 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "42px ",
                        fontSize: "50px",
                        marginLeft: "8px",
                        color: "red",
                      }}
                      onClick={() => setFields(index)}
                    >
                      <AddCircleIcon fontSize="1rem" />
                    </div>
                  ) : (
                    <div></div>
                  )}{" "}
                </Grid>
              </>
            ))}
          </Grid>
          <Button
            onClick={updateModelHandler}
            variant="contained"
            sx={{
              backgroundColor: "red",
              "&:hover": { color: "red", backgroundColor: "white" },
            }}
          >
            Save Changes
          </Button>
        </Box>
      </Modal>

      <Modal
        open={aiModalOpen}
        onClose={handleAiModalClose}
        sx={{
          border: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "80vh",
            width: { lg: "90vw" },
            padding: "2vh 2vw 4vh 2vw",
            outline: "none",
            borderRadius: "6px",
            backgroundColor: "#f8f9fa",
            position: "relative",
            marginTop: "10vh",
            marginLeft: "4vh",
          }}
        >
          <Grid sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleAiModalClose}
              sx={{ boxShadow: 2, color: "red", "&:hover": { boxShadow: 5 } }}
            >
              <CloseIcon />
            </Button>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
              mb: 3,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Mont-SemiBold",
                fontSize: "1.5rem",
              }}
            >
              Ai Data-Model Generator
            </Typography>
            <Grid
              item
              xs={8.8}
              sx={{ backgroundColor: "red", height: "1vh" }}
            ></Grid>
          </Grid>

          <div>
            <AIModelGenerator
              project={project}
              onModelGenerated={(modelData) => {
                console.log("Generated model:", modelData);
                handleAiModalClose();
                toast.success("Model created successfully!", {
                  position: "top-right",
                  autoClose: 3000,
                });
              }}
            />
          </div>
        </Box>
      </Modal>

      <ToastContainer autoClose={2000} />
    </div>
  );
}
